import { Component, OnInit } from "@angular/core";
import { UntypedFormControl, NgModel } from "@angular/forms";
import * as moment from "moment";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import { MainService } from "../services/delavci/main.service";
import { HelpdeskService } from "../services/delavci/helpdesk.service";
export const MY_FORMATS = {
  parse: {
    dateInput: "DD.MM.YYYY",
  },
  display: {
    dateInput: "DD.MM.YYYY",
    monthYearLabel: "DD.MM.YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "DD.MM.YYYY",
  },
};
import { SelectionModel } from "@angular/cdk/collections";
import { MatLegacyTableDataSource as MatTableDataSource } from "@angular/material/legacy-table";
import { Cooperations } from "../models/Cooperations";
import { Task } from "../models/Task";
import { Modules } from "../models/Modules";
import { Router } from '@angular/router';
import { timeParser } from '../utils/timeParser';
import { AnalyticsTask } from '../models/AnalyticsTask';
import { SaleService } from '../services/partner/sale.service';

@Component({
  selector: "app-analiza",
  templateUrl: "./analiza.component.html",
  styleUrls: ["./analiza.component.css"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class AnalizaComponent implements OnInit {
  public statusChecker = [
    { color: "yellow", status: 1, selected: false },
    { color: "red", status: 29, selected: false },
    { color: "blue", status: 30, selected: false },
    { color: "green", status: 26, selected: false },
    { color: "gray", status: 361, selected: false },
    { color: "brown", status: 97, selected: false },
    { color: "darkBlue", status: 385, selected: false },
    { color: "purple", status: 386, selected: false },
    { color: "black", status: 387, selected: false }
  ];

  public dateFrom = new UntypedFormControl(moment().subtract(30, "days"));
  public dateTo = new UntypedFormControl(moment());
  public cooperationsData: Array<Task>;
  public barChartData: Array<Task>;
  public href;
  public outDateFrom;
  public outDateTo;
  public selectedCooperations: Array<Cooperations>;
  public barChartWorkersData: Array<Task>;
  //table variables
  displayedColumns: string[] = ["code", "nameSmall", "select"];
  dataSource = new MatTableDataSource<Cooperations>();
  public cooperationsList: Array<Cooperations>;
  selection = new SelectionModel<Cooperations>(true, []);
  public allCooperations = [];
  displayedColumnsModules: string[] = ["code", "nameSmall", "select"];
  dataSourceModules = new MatTableDataSource<Modules>();
  selectionModules = new SelectionModel<Modules>(true, []);

  displayedColumnsProcesses: string[] = ["code", "nameSmall", "select"];
  dataSourceProcesses = new MatTableDataSource<Modules>();
  selectionProcesses = new SelectionModel<Modules>(true, []);

  public outCooperationsName = [];
  public outProcesses = [];
  public notSetYet = false;
  public notSetYetModules = false;
  public showFiller = false;
  public mobile = false;
  public onInitCall = true;
  public submitted = false;
  public showFilter;
  public chbx_helpdesk = true;
  public chbx_project = true;
  public selectorBool = true;
  public outData: Array<AnalyticsTask>;
  public imeProcesa;
  public firstInitModules: Array<Modules> = [];
  public firstInitProccesses: Array<Modules> = [];
  constructor(
    private mainService: MainService,
    private helpdeskService: HelpdeskService,
    private router: Router,
    private saleService: SaleService
  ) {}

  ngOnInit() {
    this.outDateFrom = this.dateFrom.value.format("DD.MM.YYYY");
    this.outDateTo = this.dateTo.value.format("DD.MM.YYYY");
    this.mainService.analizaFilterBool.subscribe( bool => {
      this.showFilter = bool;
    });
    this.mainService.changeHref(this.router.url);
    if (window.screen.width < 500) { // 768px portrait
      this.mobile = true;
    }
    if (this.mainService.currentUserValue) {
      this.callGetCooperations();
      this.getModules();
    }
  }

  /* koda za filter statusa*/
  filterStatusChecker(color: string) {
    for (let item of this.statusChecker) {
      if (item.color === color) {
        if (item.selected) {
          item.selected = false;
        } else {
          item.selected = true;
        }
      }
    }
  }

  callGetCooperations() {
    this.helpdeskService
      .getCooperation(this.mainService.currentUserValue.sessionUser)
      .subscribe(
        (data) => {
          this.dataSource = new MatTableDataSource(data.data.cooperations);
          this.cooperationsList = data.data.cooperations;
          let allData: Array<Cooperations> = data.data.cooperations;
          for(let item of allData) {
            this.allCooperations.push(item.nameSmall);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  onSubmitSettings() {
    this.outDateFrom = this.dateFrom.value.format("DD.MM.YYYY");
    this.outDateTo = this.dateTo.value.format("DD.MM.YYYY");
    this.notSetYet = true;
    let processesIds = [];
    let processes = [];
    this.outProcesses = [];
    for (let item of this.selectionProcesses.selected) {
      if (item.id) {
        processesIds.push(item.id);
        processes.push(item);
      }
    }

    this.outProcesses = processes;
    if(this.outProcesses.length === 0) {
        processesIds = [];
        processes = [];
        this.outProcesses = this.firstInitProccesses;
        for (let item of this.firstInitProccesses) {
          if (item.id) {
            processesIds.push(item.id);
          }
        }
    }

    let statuses = [];
    for (let item of this.statusChecker) {
      if (item.selected) {
        statuses.push(item.status);
      }
    }
    let cooperations = [];
    let cooperationsName = [];
    for (let item of this.selection.selected) {
      cooperations.push(item.id);
      cooperationsName.push(item.nameSmall);
    }
    if(cooperationsName.length === 0) {
      cooperationsName = this.allCooperations;
    }
    this.getAnalyticsCall(statuses, processesIds, cooperations, cooperationsName);

  }

  onSubmitButtonClick() {
    this.submitted = true;
    if (!this.showFilter) {
      this.showFilter = true;
      this.mainService.changeAnalizaFilterBool(this.showFilter);
    } else {
      this.showFilter = false;
      this.mainService.changeAnalizaFilterBool(this.showFilter);
    }
    this.onSubmitSettings();
  }
  getAnalyticsCall(statuses, processesIds, cooperations, cooperationsName) {
      this.helpdeskService
      .getAnalytics(
        this.mainService.currentUserValue.sessionUser,
        this.chbx_helpdesk ? 1 : 0, this.chbx_project  ? 1 : 0, statuses, cooperations,
        processesIds,
        moment(this.dateFrom.value).format("DD.MM.YYYY"),
        moment(this.dateTo.value).format("DD.MM.YYYY")
      ).subscribe(
        (data) => {
          if(this.imeProcesa) {
            this.outData = [];
            for(let element of data.data.tasks) {
                if(element.process.toUpperCase() === this.imeProcesa.toUpperCase()) {
                  this.timeParser(this.outData);
                  this.outData.push(element);
                }
            }
          } else {
              this.outData = this.timeParser(data.data.tasks);
          }
          this.barChartData = data.data.tasks;
          this.outCooperationsName = cooperationsName;
          if(cooperationsName == null) {
            this.outCooperationsName = this.allCooperations;
          }

          this.barChartWorkersData = data.data.tasks; //workers graph
          this.submitted = false;
        },
        (error) => {
          console.log(error);
        }
      );

  }

  selectAll(select: NgModel, values) {
    if (this.selectorBool) {
      select.update.emit(values);
      this.selectorBool = false;
    } else {
      select.update.emit([]);
      this.selectorBool = true;
    }
  }

  timeParser(data) {
    for (let element of data) {
      let year,month, day, h, min, sec;
      /* tsEvent
      2020-01-17 15:31:07.0*/
      year = element.date.substring(0, 4);
      month = element.date.substring(5, 7);
      day = element.date.substring(8, 10);
      element.date = day + "." + month + "." + year;

    }

    return data;
  }

  //pie chart
  getModules() {
    this.firstInitModules = [];
    this.helpdeskService
      .getModulesAnaliza(this.mainService.currentUserValue)
      .subscribe(
        (data) => {
          this.dataSourceModules = new MatTableDataSource(data.data.modules);
          let allData: Array<Modules> = data.data.modules;
          for(let item of allData) {
            this.firstInitModules.push(item);
          }
          this.submitModules();
          this.notSetYetModules = false;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  submitModules() {
    this.firstInitProccesses = [];
    this.notSetYetModules = true;
    this.selectionProcesses = new SelectionModel<Modules>(true, []);
    let moduleIds = [];
    for (let item of this.firstInitModules){
      moduleIds.push(item.id);
    }
    this.helpdeskService.getProcessesForGraphTable(this.mainService.currentUserValue, moduleIds, null).subscribe( data => {
      this.dataSourceProcesses = new MatTableDataSource(data.data.modules);
      let allData: Array<Modules> = data.data.modules;
      for(let item of allData) {
        this.firstInitProccesses.push(item);
      }
      this.onSubmitSettings();
    }, error => {
      console.log(error);
    });

  }

  /* Koda za checkboxe */
  //COOPERATIONS
  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }
  //COOPERATIONS
  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => this.selection.select(row));
  }
  //COOPERATIONS
  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: Cooperations): string {
    if (!row) {
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${
      row.id + 1
    }`;
  }

  //MODULES
  isAllSelectedForModules() {
    const numSelected = this.selectionModules.selected.length;
    const numRows = this.dataSourceModules.data.length;
    return numSelected === numRows;
  }
  //MODULES
  masterToggleForModules() {
    this.isAllSelectedForModules()
      ? this.selectionModules.clear()
      : this.dataSourceModules.data.forEach((row) => this.selectionModules.select(row));
    this.selectionProcesses.clear();
    this.notSetYetModules = false;
  }

  //MODULES
  checkboxLabelForModules(row?: Modules): string {
    if (!row) {
      return `${this.isAllSelectedForModules() ? "select" : "deselect"} all`;
    }
    return `${this.selectionModules.isSelected(row) ? "deselect" : "select"} row ${
      row.id + 1
    }`;
  }

  //PROCESSES
  isAllSelectedForProcesses() {
    const numSelected = this.selectionProcesses.selected.length;
    const numRows = this.dataSourceProcesses.data.length;
    return numSelected === numRows;
  }
  //PROCESSES
  masterToggleForProcesses() {
    this.isAllSelectedForProcesses()
      ? this.selectionProcesses.clear()
      : this.dataSourceProcesses.data.forEach((row) => this.selectionProcesses.select(row));
  }
  //PROCESSES
  checkboxLabelForProcesses(row?: Modules): string {
    if (!row) {
      return `${this.isAllSelectedForProcesses() ? "select" : "deselect"} all`;
    }
    return `${this.selectionProcesses.isSelected(row) ? "deselect" : "select"} row ${
      row.id + 1
    }`;
  }

}

